import React from "react";
import { connect } from "react-redux";

import EmptyModal from "../modals/EmptyModal";
import { useAuditHistoryLoader } from "../../viewmodels/audit/useAuditHistoryLoader";
import { useAuditHistoryViewModel } from "../../viewmodels/audit/useAuditHistoryViewModel";
import * as actions from "../../store/actions/index";
import AuditHistory from "./AuditHistory";

function EmbeddedAuditHistory({
  entityId,
  entityType,
  logout,
  addSnackbar,
  enabled = true,
}) {
  const auditVm = useAuditHistoryViewModel(
    logout,
    entityId,
    entityType,
    addSnackbar,
  );
  const { emptyModal, setEmptyModelOpen } = auditVm;

  useAuditHistoryLoader(
    auditVm,
    enabled && Boolean(entityType && entityId),
  );

  return (
    <>
      <div className="mt-6 rounded-[18px] border border-[#E2E8F0] bg-white p-5 shadow-[0_1px_2px_rgba(15,23,42,0.04)] sm:p-6">
        <h2 className="mb-4 text-base font-semibold text-[#0F172A]">
          Change history
        </h2>
        <AuditHistory vm={auditVm} />
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
    </>
  );
}

const mapDispatchToProps = (dispatch) => ({
  addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
});

export default connect(null, mapDispatchToProps)(EmbeddedAuditHistory);
